import React, {memo, useMemo} from "react";

import "./Filter.sass";
import onClickOutside from "react-onclickoutside";
import {ReactComponent as Tick} from "../../svg/Tick.svg";
import {ReactComponent as Cliker} from "../../svg/Cliker.svg";
import {ReactComponent as Cuff} from "../../svg/Cuff.svg";
import {ReactComponent as Labret} from "../../svg/Labret.svg";

const {Translations: {filters}} = window;
const typeSVG = {
    1: Cliker,
    2: Labret,
    3: Cuff,
};

function Filter({options, isOpen, optionButton, onOptionChange,onClear, filter}) {
    const renderOption = Object.entries(options).map((option, key) => {
        const filterType =  option[0];
        const currentFilterOption = filter[option[0]];
        const isArrayOption = Array.isArray(currentFilterOption);
        return <div className="Filter-section" key={key}>
            <div className="Filter-section-title">{option[1].title}:</div>
            {Object.entries(option[1].options).map((item, i) => {
                const value = isNaN(Number(item[0])) ? item[0] === "true" : Number(item[0]);
                const isActive = isArrayOption ? currentFilterOption.includes(Number(item[0])) : filter[option[0]] === value;
                let Icon = filterType === "type" && typeSVG[value];
                return <div
                    key={i}
                    className={`Filter-section-option ${isActive ? "active" : ""}`}
                    onClick={() => onOptionChange(filterType, value )}>
                {item[1]}
                {filterType === "type" &&
                    <Icon className="Filter-section-icon"/>
                }
                <Tick />
            </div>})}
        </div>
    });
    const renderOptions = useMemo(() => {
        return renderOption
    }, [renderOption]);

    return (<div className={`Filter ${isOpen ? "Filter-open" : ""}`}>
        <div className="Filter-options">
            {optionButton}
            <button className={`Filter-btn Filter-clear`} onClick={onClear}>{filters.buttons.clearBtn}</button>
        </div>
        <div className="Filter-content">
            {renderOptions}
        </div>
    </div>)
};
;
export default memo(onClickOutside(Filter));
